module.exports = __webpack_public_path__ + "img/login.f486af9e.jpg";